export function trueFalse(value) {
    if (value === true) {
        return "Yes";
    }
    return "No";
}